import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getOrgCode } from '../../../helper/utils.helper';
import { getAllCourses } from '../../../helper/api.helper';
import toast from 'react-hot-toast';
import CourseListSkeletonLoader from './CourseListSkeletonLoader';
import CourseItem from './CourseItem';
import InstituteDetails from '../home/institute-details/InstituteDetails';

const CourseList = () => {
  const [allCourses, setAllCourses] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const orgCode = getOrgCode();
    getAllCourses(orgCode)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          setAllCourses(res.data);
        } else {
          toast.error(res.message);
          navigate('/');
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
      });
  }, []);

  return (
    <div className="course-list-wrapper">
      {isLoading ? (
        <div className="skeleton-div">
          <CourseListSkeletonLoader />
        </div>
      ) : (
        <div
          style={{
            padding: window.innerWidth > 600 ? 'var(--space-lg)' : 'var(--space-md)'
          }}>
          <div className="margin-bottom--lg">
            <InstituteDetails />
          </div>
          <div className="inner-div">
            {allCourses?.map((course, index) => (
              <CourseItem course={course} key={index} />
            ))}
          </div>
        </div>
      )}
      <style jsx>
        {`
          .course-list-wrapper {
            min-height: 90vh;
            display: flex;
            justify-content: center;
            max-width: 1150px;
            margin: auto;
          }
          .skeleton-div {
            flex-grow: 1;
            padding-bottom: 20px;
          }
          .inner-div {
            width: 70%;
            max-width: 900px;
            padding-bottom: 20px;
            margin: auto;
          }
          @media only screen and (max-width: 1050px) {
            .inner-div {
              width: 80%;
            }
          }
          @media only screen and (max-width: 950px) {
            .inner-div {
              width: 95%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CourseList;
